import { Autocomplete, Chip, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'; 
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import workflowStyle from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss';
import waCampaignStyles from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import contactStyle from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import fieldStyles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss' 
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from "../../../services/api";
import { useSearchParams } from 'react-router-dom';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../context/flowBuilderContext';
import { actionTypeArray, emptyPostDeploymentTriggerDataObj } from './flowBuilderConstants';
import CloseIcon from '@mui/icons-material/Close';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import EditIcon from '@mui/icons-material/Edit';
import { chatbot_step_get_post_deployment_trigger, getDeploymentTriggerPayload, postDeploymentTriggerPayload } from '../../../models/flowBuilderTypes';
import { generateUUID } from '../../../utils/constants';
import { PersonalVideo } from '@mui/icons-material';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface PostDeploymentTriggerProps {
    setFlagOpenKeywordsPopup: React.Dispatch<React.SetStateAction<boolean>>,
} 

const PostDeploymentTrigger: React.FC<PostDeploymentTriggerProps> = (props) => {

    const { setFlagOpenKeywordsPopup } = props;
    const { handleError, setFlagLoading } = useContext(UserContext) as UserContextPayload 
    const { getChatbotPostDeploymentTriggerApi, getChatbotPostDeploymentTriggerTypeApi, chatbotPostDeploymentTriggerType, chatbotPostDeploymentTrigger, setChatbotPostDeploymentTrigger} = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const innerHeight = (window.innerHeight - 300);
    const [searchParams] = useSearchParams();
    const chatbotId = searchParams.get('workflow_id');

    const [savedChatbotPostDeploymentTrigger, setSavedChatbotPostDeploymentTrigger] = useState<getDeploymentTriggerPayload[] | null>(null);

    const [editPostDeploymentDataId, setEditPostDeploymentDataId] = useState<string[]>([]);
    const [typedKeywordValue, setTypedKeywordValue] = useState<any>({
        value: "", 
        id: null,
    });

    const getChatbotPostDeploymentTriggerApiCall = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getChatbotPostDeploymentTriggerApi(chatbotId || ""); 
        if(res.status && res.data){ 
            const keywordTrigger = res.data?.filter((trigger: any) => {
                return trigger?.chatbot_post_deployment_trigger_type?.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "keyword";
            })
            setSavedChatbotPostDeploymentTrigger(keywordTrigger);
        } else {
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    } 

    const getChatbotPostDeploymentTriggerTypeApiCall = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getChatbotPostDeploymentTriggerTypeApi(); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    useEffect(() => {
        getChatbotPostDeploymentTriggerApiCall(); 

        if(!chatbotPostDeploymentTriggerType){
            getChatbotPostDeploymentTriggerTypeApiCall();
        }
    }, []);

    const handleOnChangeOfKeywords = (filtered: string[], chatbot_post_deployment_trigger_id: string) => {
        setChatbotPostDeploymentTrigger((prev) => {
            if(!prev) return prev;
            return prev?.map((tri) => {
                if(tri.chatbot_post_deployment_trigger_id == chatbot_post_deployment_trigger_id){
                    return {
                        ...tri, 
                        condition_group: {
                            ...tri.condition_group, 
                            condition_values: filtered,
                        }
                    }
                }
                return tri;
            })
        })
    }

    const disableUpdatePostDeploymentTrigger = (trigger: getDeploymentTriggerPayload) => {
        if(trigger.condition_group?.condition_values?.length > 0 && trigger.action_type){
            if(trigger.action_type?.toLowerCase() == "redirect"){
                if(trigger.chatbot_step?.chatbot_step_id){
                    return false; 
                } else return true;
            } 
            return false;
        }
        return true;
    }

    const removeCurrentTriggerFromEditList = (chatbot_post_deployment_trigger_id: string) => {
        setEditPostDeploymentDataId((prev) => {
            if(!prev) return prev; 
            return prev.filter((id) => id != chatbot_post_deployment_trigger_id);
        });
    }

    const handlePostDeploymentTrigger = async (trigger: getDeploymentTriggerPayload, isEditBtn: boolean) => { 
        if(!disableUpdatePostDeploymentTrigger(trigger)){
            setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));   
            if(isEditBtn) {
                setEditPostDeploymentDataId((prev) => {
                    if(!prev) return [trigger.chatbot_post_deployment_trigger_id]; 
                    return [...prev, trigger.chatbot_post_deployment_trigger_id];
                });
                    
            } else { 
                let flagSamePayload = false;
                const currentTrigger = savedChatbotPostDeploymentTrigger?.find((tri) => tri.chatbot_post_deployment_trigger_id == trigger.chatbot_post_deployment_trigger_id); 
                if(currentTrigger){
                    const { action_type: action_type1, ...restTrigger } = trigger;
                    const { action_type: action_type2, ...savedTrigger } = currentTrigger; 
                    if(JSON.stringify(restTrigger) == JSON.stringify(savedTrigger)){
                        flagSamePayload = true;
                    }
                }
                if(!flagSamePayload){
                    let payload = trigger;
                    payload = {
                        ...payload, 
                        chatbot_post_deployment_trigger_id: payload.chatbot_post_deployment_trigger_id || generateUUID(),
                        chatbot_post_deployment_trigger_type: chatbotPostDeploymentTriggerType?.find((trigger) => trigger.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "keyword") || payload.chatbot_post_deployment_trigger_type
                    }
                    
                    const res = await agent.handleChatbotPostDeploymentTrigger.post(payload, chatbotId || "");
                    if(!res.status){
                        handleError(res);
                    } else {
                        showSuccess(`Keywords ${trigger.chatbot_post_deployment_trigger_id ? `updated` : 'created'} successfully!`)
                        setSavedChatbotPostDeploymentTrigger((prev) => {
                            if(!prev) return prev;  
                            if(trigger.chatbot_post_deployment_trigger_id == ""){
                                return [...prev, {...trigger, chatbot_post_deployment_trigger_id: payload.chatbot_post_deployment_trigger_id}]
                            } 
                            return prev?.map((tri) => {
                                if(tri.chatbot_post_deployment_trigger_id == trigger.chatbot_post_deployment_trigger_id){
                                    return {
                                        ...trigger, 
                                        chatbot_post_deployment_trigger_id: payload.chatbot_post_deployment_trigger_id,
                                    }
                                }
                                return tri;
                            });
                        })
                    }
                    removeCurrentTriggerFromEditList(trigger.chatbot_post_deployment_trigger_id);
                    setChatbotPostDeploymentTrigger((prev) => {
                        if(!prev) return prev; 
                        return prev?.map((tri) => {
                            if(tri.chatbot_post_deployment_trigger_id == ""){
                                return {
                                    ...tri, 
                                    chatbot_post_deployment_trigger_id: payload.chatbot_post_deployment_trigger_id,
                                }
                            }
                            return tri;
                        });
                    });
                } else {
                    showSuccess(`Keywords ${trigger.chatbot_post_deployment_trigger_id ? `updated` : 'created'} successfully!`)
                    removeCurrentTriggerFromEditList(trigger.chatbot_post_deployment_trigger_id);
                }
            }
            setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
        }
    } 

    const deletePostDeploymentTrigger = async (trigger: getDeploymentTriggerPayload) => { 
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true})); 
        let payload: postDeploymentTriggerPayload = trigger;
        if(trigger.chatbot_post_deployment_trigger_id == "") {
            setChatbotPostDeploymentTrigger((prev) => {
                if(!prev) return prev; 
                return prev?.filter((tri) => tri.chatbot_post_deployment_trigger_id?.length > 0);
            });
        } else {
            payload = {
                ...payload,  
                flag_deleted: true,
                chatbot_post_deployment_trigger_type: chatbotPostDeploymentTriggerType?.find((trigger) => trigger.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "keyword") || payload.chatbot_post_deployment_trigger_type
            } 

            const res = await agent.handleChatbotPostDeploymentTrigger.post(payload, chatbotId || "");
            if(!(res.status)){
                handleError(res);
            } else { 
                showSuccess("Keywords deleted successfully!")
                setChatbotPostDeploymentTrigger((prev) => {
                    if(!prev) return prev; 
                    return prev.filter((tri) => tri.chatbot_post_deployment_trigger_id != trigger.chatbot_post_deployment_trigger_id);
                }); 
                setSavedChatbotPostDeploymentTrigger((prev) => {
                    if(!prev) return prev; 
                    return prev.filter((tri) => tri.chatbot_post_deployment_trigger_id != trigger.chatbot_post_deployment_trigger_id);
                })
            }
        } 
        setEditPostDeploymentDataId((prev) => {
            if(!prev) return prev;
            return prev.filter((tri) => tri != trigger.chatbot_post_deployment_trigger_id);
        });
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    } 

    const onKeyDownOfSaveUpdateIcon = (e: React.KeyboardEvent<HTMLDivElement>, trigger: getDeploymentTriggerPayload, isEditing: boolean) => {
        if(e.key == "Enter"){
            handlePostDeploymentTrigger(trigger, !(isEditing));
        }
    } 

    const onKeyDownOfDeleteIcon = (e: React.KeyboardEvent<HTMLDivElement>, trigger: getDeploymentTriggerPayload) => {
        if(e.key == "Enter"){
            deletePostDeploymentTrigger(trigger);
        }
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>Set Keyword-Based Routing</Typography>
                        </Grid>
                        
                        <Divider className={style.popupTitleDivider} />

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item className={globalStyles.fullwidth}>
                                    <TableContainer className={workflowStyle.postDeploymentTriggerTable} sx={{ maxHeight: `${innerHeight}px !important` }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Keywords</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Action Type</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Chatbot Step</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Text Message 
                                                        {/* <span style={{color: '#888', fontWeight: 400}}>(Optional, sent to user before action)</span> */}
                                                    </TableCell>
                                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${dashboardStyles.viewButtonColumnHeadingStyle}`}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {chatbotPostDeploymentTrigger && chatbotPostDeploymentTrigger?.length > 0 ? 
                                                    chatbotPostDeploymentTrigger.map((trigger) => {
                                                        const isEditing = editPostDeploymentDataId.includes(trigger.chatbot_post_deployment_trigger_id);
                                                        return (
                                                            <TableRow className={dashboardStyles.cellRow}>
                                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                    {isEditing ? (
                                                                        <Autocomplete
                                                                            className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${workflowStyle.keywordFreeSolo}`}
                                                                            freeSolo
                                                                            options={[]}
                                                                            multiple
                                                                            value={trigger.condition_group?.condition_values || []} 
                                                                            renderTags={(value, getTagProps) =>
                                                                                value.map((option, index) => (
                                                                                    <Chip
                                                                                        label={option}
                                                                                        deleteIcon={<CloseIcon />}
                                                                                        {...getTagProps({ index })} 
                                                                                        sx={{
                                                                                            whiteSpace: "normal", 
                                                                                            wordBreak: "break-word",
                                                                                            padding: "4px 0px",
                                                                                            height: "auto",
                                                                                        }}
                                                                                    />
                                                                                ))
                                                                            } 
                                                                            inputValue={typedKeywordValue.id == trigger.chatbot_post_deployment_trigger_id ? typedKeywordValue.value : ""}
                                                                            onInputChange={(e, val) => {
                                                                                setTypedKeywordValue((prev: any) => ({
                                                                                    ...prev, 
                                                                                    value: val, 
                                                                                    id: trigger.chatbot_post_deployment_trigger_id,
                                                                                }));
                                                                            }}
                                                                            onChange={(e, newValue) => {
                                                                                const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                                                                handleOnChangeOfKeywords(filtered, trigger.chatbot_post_deployment_trigger_id);
                                                                            }}
                                                                            renderInput={params => {
                                                                                const { InputProps, ...restParams } = params;
                                                                                const { startAdornment, ...restInputProps } = InputProps;
                                                                                return (
                                                                                    <TextField
                                                                                        {...restParams}
                                                                                        placeholder='Enter Keywords' 
                                                                                        onBlur={() => {
                                                                                            if (typedKeywordValue.value.trim().length > 0) { 
                                                                                                const currentVal = trigger.condition_group?.condition_values || [];
                                                                                                if(!currentVal.find((val) => val == typedKeywordValue.value.trim())){
                                                                                                    const newVal = [...currentVal, typedKeywordValue.value.trim()];
                                                                                                    handleOnChangeOfKeywords(newVal, trigger.chatbot_post_deployment_trigger_id);
                                                                                                    setTypedKeywordValue({
                                                                                                        value: "", 
                                                                                                        id: null,
                                                                                                    }); 
                                                                                                }
                                                                                            }
                                                                                        }}
                                                                                        InputProps={{
                                                                                            ...restInputProps,
                                                                                            startAdornment: (
                                                                                                <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                                                    {startAdornment}
                                                                                                </div>
                                                                                            ),
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        trigger.condition_group?.condition_values?.join(", ")
                                                                    )}
                                                                    {(typedKeywordValue.value.trim().length > 0  && typedKeywordValue.id == trigger.chatbot_post_deployment_trigger_id )&& 
                                                                        <Grid item className={fieldStyles.pressEnterTypography} sx={{whiteSpace: "normal", wordBreak: "break-all"}}>
                                                                            Press Enter to save {typedKeywordValue.value}
                                                                        </Grid>
                                                                    }
                                                                </TableCell>
                                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                    {isEditing ? (
                                                                        <Autocomplete
                                                                            sx={{ minWidth: "150px" }}
                                                                            className={globalStyles.autocompleteParaphrasing}
                                                                            getOptionLabel={(option) => option || ""}
                                                                            value={actionTypeArray?.find((tri) => tri.toLowerCase() == trigger.action_type?.toLowerCase()) ?? undefined}
                                                                            options={actionTypeArray || []}
                                                                            onChange={(e, value) => { 
                                                                                let chatbotStep: chatbot_step_get_post_deployment_trigger = {
                                                                                    chatbot_step_id: "", 
                                                                                    chatbot_step_name: "", 
                                                                                    chatbot_step_type: {
                                                                                        chatbot_step_type_id: "", 
                                                                                        chatbot_step_type_name: "",
                                                                                    }
                                                                                };
                                                                                if(value.toLowerCase() == "redeploy"){
                                                                                    const redeployStep = currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version?.chatbot_version_status_name?.toLowerCase() == "published")?.chatbot_step_data?.find((step) => step.chatbot_step_type?.chatbot_step_type_name?.toLowerCase() == "redeploy");
                                                                                    chatbotStep = {
                                                                                        chatbot_step_id: redeployStep?.chatbot_step_id || "", 
                                                                                        chatbot_step_name: redeployStep?.chatbot_step_name || "", 
                                                                                        chatbot_step_type: redeployStep?.chatbot_step_type || {
                                                                                            chatbot_step_type_id: "", 
                                                                                            chatbot_step_type_name: "",
                                                                                        }
                                                                                    }
                                                                                }
                                                                                setChatbotPostDeploymentTrigger((prev) => {
                                                                                    if(!prev) return prev;
                                                                                    return prev.map((tri) => {
                                                                                        if(tri.chatbot_post_deployment_trigger_id == trigger.chatbot_post_deployment_trigger_id){
                                                                                            return {
                                                                                                ...tri, 
                                                                                                action_type: value,
                                                                                                chatbot_step: chatbotStep,
                                                                                            }
                                                                                        } 
                                                                                        return tri;
                                                                                    })
                                                                                });
                                                                            }}
                                                                            renderInput={(params) => <TextField {...params} placeholder='Select Action Type' />}
                                                                            disableClearable
                                                                        />
                                                                    ) : (
                                                                        trigger.action_type
                                                                    )}
                                                                </TableCell>
                                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                    {isEditing ? (
                                                                        trigger.action_type?.toLowerCase() === "redirect" ? (
                                                                            <Autocomplete
                                                                                sx={{ minWidth: "150px" }}
                                                                                className={globalStyles.autocompleteParaphrasing}
                                                                                getOptionLabel={(option) => option.chatbot_step_name || ""}
                                                                                value={currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == "published")?.chatbot_step_data?.find((step) => step.chatbot_step_id == trigger.chatbot_step?.chatbot_step_id) ?? undefined}
                                                                                options={currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == "published")?.chatbot_step_data?.filter((step) => step.chatbot_step_type?.chatbot_step_type_name?.toLowerCase() != "redeploy") || []}
                                                                                onChange={(e, value) => {
                                                                                    setChatbotPostDeploymentTrigger((prev) => {
                                                                                        if(!prev) return prev;
                                                                                        return prev.map((tri) => {
                                                                                            if(tri.chatbot_post_deployment_trigger_id == trigger.chatbot_post_deployment_trigger_id){
                                                                                                return {
                                                                                                    ...tri,
                                                                                                    chatbot_step: value ? {
                                                                                                        chatbot_step_id: value.chatbot_step_id,
                                                                                                        chatbot_step_name: value.chatbot_step_name,
                                                                                                        chatbot_step_type: (value as any).chatbot_step_type || { chatbot_step_type_id: "", chatbot_step_type_name: "" }
                                                                                                    } : {
                                                                                                        chatbot_step_id: "",
                                                                                                        chatbot_step_name: "",
                                                                                                        chatbot_step_type: { chatbot_step_type_id: "", chatbot_step_type_name: "" }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            return tri;
                                                                                        })
                                                                                    })
                                                                                }}
                                                                                renderInput={(params) => <TextField {...params} placeholder='Select' />}
                                                                            />
                                                                        ) : (
                                                                            <span>NA</span>
                                                                        )
                                                                    ) : (
                                                                        trigger.action_type?.toLowerCase() == "redirect" ? 
                                                                            trigger.chatbot_step?.chatbot_step_name || "-"
                                                                        : "NA"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            value={trigger.pre_transition_text_message}
                                                                            onChange={(e) => {  
                                                                                setChatbotPostDeploymentTrigger((prev) => {
                                                                                    if(!prev) return prev;
                                                                                    return prev.map((tri) => {
                                                                                        if(tri.chatbot_post_deployment_trigger_id == trigger.chatbot_post_deployment_trigger_id){
                                                                                            return {
                                                                                                ...tri, 
                                                                                                pre_transition_text_message: e.target.value,
                                                                                            }
                                                                                        }
                                                                                        return tri;
                                                                                    })
                                                                                })
                                                                            }}
                                                                            className={`${contactStyle.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                                                            sx={{background: "white", minWidth: 350, maxWidth: 500}}
                                                                            placeholder={`Enter message`}
                                                                        />
                                                                    ) : (
                                                                        trigger.pre_transition_text_message || "-"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable} ${dashboardStyles.viewButtonColumnStyle}`} sx={{ textAlign: "end" }}> 
                                                                    <Grid container gap={"5px"} flexWrap={"nowrap"}>
                                                                        <Grid item className={globalStyles.clickable} tabIndex={0} onKeyDown={(e) => onKeyDownOfSaveUpdateIcon(e, trigger, isEditing)} onClick={() => handlePostDeploymentTrigger(trigger, !(isEditing))}>
                                                                            {isEditing ?  
                                                                                <SaveAsIcon className={`${style.actionIcons} ${disableUpdatePostDeploymentTrigger(trigger) ? style.disableActionIcons : style.actionIcons}`} />
                                                                                :
                                                                                <EditIcon className={`${style.actionIcons} ${disableUpdatePostDeploymentTrigger(trigger) ? style.disableActionIcons : style.actionIcons}`} />
                                                                            }
                                                                        </Grid>
                                                                        <Grid item className={globalStyles.clickable} tabIndex={0} onKeyDown={(e) => onKeyDownOfDeleteIcon(e, trigger)} onClick={() => deletePostDeploymentTrigger(trigger)}>
                                                                            <DeleteIcon className={`${style.actionIcons}`} />
                                                                        </Grid>
                                                                    </Grid>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                    :
                                                    <TableRow className={dashboardStyles.cellRow}>
                                                        <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                            No Data Available
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item className={globalStyles.fullwidth}> 
                                    <Grid container className={`${globalStyles.alignItemCenter}`}>
                                        <GlobalButton
                                            buttonText="Add"
                                            startIcon={<AddIcon />}
                                            className='primaryButtonStyle'
                                            sx={{ width: "100px" }}
                                            disabled={editPostDeploymentDataId.includes("")}
                                            onClick={() => {
                                                setChatbotPostDeploymentTrigger((prev) => {
                                                    if(!prev) return [emptyPostDeploymentTriggerDataObj];
                                                    return [...prev, emptyPostDeploymentTriggerDataObj];
                                                }); 
                                                // setEditPostDeploymentDataId(""); 
                                                setEditPostDeploymentDataId((prev) => [...prev, ""]);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default PostDeploymentTrigger
